<template>
  <div class="cell-container">
    <!-- <div class="image-container height386">
      <img src="@/assets/ksxg/banner01.png" />
    </div> -->
    <Tabbar></Tabbar>
    <router-view></router-view>
  </div>
</template>

<script>
import Tabbar from "@/components/AboutExamination/Tabbar";
export default {
  components: {
    Tabbar
  },
  data() {
    return {
      imageDate: [
        {
          imagePath: require("@/assets/home/banner_index01.png"),
          bgColor: "#060a3c"
        },
        {
          imagePath: require("@/assets/home/02.png"),
          bgColor: "#f3be00"
        },
        {
          imagePath: require("@/assets/home/03.png"),
          bgColor: "#14514c"
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.height386 {
  height: 386px;
  display: flex;
  justify-content: space-around;
}
.image-container {
  background-color: #0066cc;
  text-align: center;
}
</style>
